// extracted by mini-css-extract-plugin
export default {"switch":"Switcher_switch__vG0sI","item":"Switcher_item__aGcgu","itemActive":"Switcher_itemActive__TXAHo"};